<template>
  <v-dialog persistent v-model="showSelf" max-width="600px">
    <v-form ref="form" lazy-validation>
      <v-card>
        <v-card-title class="modalHeader">
          <span class="headline">メンバーセキュリティ設定</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" class="pb-0">
                <h3 class="subtitle pb-3">メンバーの二要素認証</h3>

                ログイン操作が行われた際に確認コードを記載したメールを送信します。
                <div class="note error--text">※このアカウントが持つ全グループのメンバーに適用されます。</div>
                <div class="note pb-3 error--text">※受付アプリのログインには適用されません。</div>

                <v-radio-group v-model="editedItem.tfaSetting" :mandatory="true">
                  <template v-for="tfaSettingItem in memberTfaSettingItems">
                    <v-radio :value="tfaSettingItem.value" class="tfaSettingRadio">
                      <template slot="label">
                          <span class="tfaSettingLabel">
                            {{tfaSettingItem.label}}
                          </span>
                      </template>
                    </v-radio>
                  </template>
                </v-radio-group>
              </v-col>
              <v-col cols="12" v-if="editedItem.tfaSetting == TFA_SETTING.MEMBER_SELECT" class="pt-0">
                <v-radio-group v-model="editedItem.defaultNeedTfa" :mandatory="true" class="ml-10 mt-0" label="新規メンバーを招待する際の初期設定">
                  <template v-for="defaultNeedTfaItem in memberDefaultNeedTfaItems">
                    <v-radio :value="defaultNeedTfaItem.value" class="defaultNeedTfaRadio">
                      <template slot="label">
                          <span class="defaultNeedTfaLabel">
                            {{defaultNeedTfaItem.label}}
                          </span>
                      </template>
                    </v-radio>
                  </template>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="edit-b" @click="this.closeSelf">閉じる</v-btn>
          <v-btn color="error" @click="save">保存</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import commonTfaMixin from "@/mixins/commonTfa"
import vuetifyUtil from "@/mixins/vuetifyUtil";
import {
  getTfaSettings,
  setTfaSettings
} from '../APIUtils'
export default {
  name: 'GroupMemberSecurityEditDialog',
  mixins: [
    commonTfaMixin,
    vuetifyUtil
  ],
  data() {
    return {
      showSelf: false,

      memberTfaSettingItems: [],
      memberDefaultNeedTfaItems: [
        {
          value: true,
          label: '二要素認証を使用する（推奨）',
        },
        {
          value: false,
          label: '二要素認証を使用しない',
        },
      ],
      editedItem: {
        tfaSetting: null,
        defaultNeedTfa: null,
      }
    }
  },
  methods: {
    getMemberTfaSettingItems() {
      return [
        {
          value: this.TFA_SETTING.CLIENT_FORCE,
          label: '使用を強制（推奨）',
        },
        {
          value: this.TFA_SETTING.MEMBER_SELECT,
          label: '使用有無を選択させる',
        }
      ]
    },
    open() {
      this.memberTfaSettingItems = this.getMemberTfaSettingItems()

      getTfaSettings()
        .then(res => {
          this.editedItem.tfaSetting = res.data.tfaSetting
          this.editedItem.defaultNeedTfa = res.data.defaultNeedTfa

          if(!this.isTfaClientSelect(res.data.tfaSetting)) {
            alert("設定の更新がありました。リロードします。")
            this.$emit("reload")
            return
          }

          this.showSelf = true
        })
        .catch(err => {
          console.log(err)
          alert("エラーが発生しました")
          return
        })
    },
    closeSelf() {
      this.showSelf = false
    },
    save() {
      setTfaSettings({
        data: {
          ...this.editedItem
        }
      }).then(res => {
        alert('セキュリティ設定を更新しました。')
        this.closeSelf()
      }).catch(err => {
        console.log("err",err)
        alert('セキュリティ設定の更新に失敗しました。')
      })
    },
  }
}
</script>

<style scoped>
.modalHeader{
  background-color: #263238;
  color: white;
  height: 70px;
  font-size:160%;
  font-weight:bold;
  filter:alpha(opacity=100);
  -moz-opacity: 1;
  opacity: 1;
}
.note{
  text-align: left;
  font-size:14px;
}
</style>
